<picture [class.loading]="this.loading">
  <ng-container *ngIf="!external">
    <source *ngFor="let format of formats" [type]="'image/' + format" [srcset]="srcset + '.' + format">
  </ng-container>
  <img [src]="src || (srcset + '.' + formats[formats.length - 1])" [alt]="alt" (load)="presentImage()"
       [style]="encapsulate == 'width' ? {width: '100%'} : {height: '100%'}"/>
</picture>

<mat-spinner *ngIf="this.loading && this.showSpinner"></mat-spinner>
